import { useLoadSwiper } from "@library/shared";
import { useEffect } from "react";
import { useTimelineCtx } from "../ctx";

declare const Swiper: any;

export const useTimelineHorizontalSwiper = () => {
  const { comboId, totalAmtOfItems } = useTimelineCtx();
  const isLoaded = useLoadSwiper();

  useEffect(() => {
    if (!isLoaded) return;

    // `[data-layer-id]` already scopes to a single combo on the page;
    // the older `.storyContent` prefix isn't always in the ancestor
    // chain (e.g. local dev, embedded preview).
    const layer = `[data-layer-id="${comboId}"] .timeline-combo`;

    const swiperSets = new Swiper(`${layer} .swiper`, {
      cssMode: true,
      spaceBetween: 0,
      direction: "horizontal",
      slidesPerView: totalAmtOfItems === 1 ? 1 : 1.1,
      speed: 400,
    });

    return () => {
      if (swiperSets) {
        swiperSets.destroy();
      }
    };
  }, [isLoaded, comboId]);
};
